import { useQuery } from '@tanstack/react-query'

import { useApiContext } from '../context/ApiContext'

export function useMusicTracks(categoryId: string) {
  const { apiClient } = useApiContext()

  return useQuery(['music-tracks'], () => apiClient.getMusicTracks(categoryId), { retry: 2 })
}
